import React, { useState, useEffect } from 'react';
import { FiCheck, FiStar, FiArrowRight, FiCode, FiTrendingUp, FiCalendar, FiShield, FiChevronDown } from 'react-icons/fi';
import axios from 'axios';

function Precos() {
  const [servicos, setServicos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tipoAtivo, setTipoAtivo] = useState('tecnologia');
  const [servicoSelecionado, setServicoSelecionado] = useState(null);
  const [mobileAberto, setMobileAberto] = useState(false);

  const DESCONTO_PIX = 0.15;

  useEffect(() => {
    fetchServicos();
  }, []);

  const fetchServicos = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/servicos-catalogo`);
      
      const servicosFormatados = response.data.map(s => ({
        ...s,
        id: Number(s.id),
        preco_vista: Number(s.preco_vista),
        parcelas: Number(s.parcelas),
        ordem: Number(s.ordem),
        destaque: s.destaque === 1 || s.destaque === true
      }));
      
      const ordenados = servicosFormatados.sort((a, b) => {
        if (a.destaque && !b.destaque) return -1;
        if (!a.destaque && b.destaque) return 1;
        return (a.ordem || 0) - (b.ordem || 0);
      });
      
      setServicos(ordenados);
      
      const primeiroTec = ordenados.find(s => s.tipo === 'tecnologia' && s.destaque);
      setServicoSelecionado(primeiroTec?.id || ordenados.find(s => s.tipo === 'tecnologia')?.id);
    } catch (error) {
      console.error('Erro ao carregar serviços:', error);
    } finally {
      setLoading(false);
    }
  };

  const calcularPrecoPix = (preco) => (preco * (1 - DESCONTO_PIX)).toFixed(2);
  const calcularParcela = (preco, vezes) => vezes <= 1 ? preco.toFixed(2) : (preco / vezes).toFixed(2);

  const formatEspecificacoes = (especs) => {
    if (!especs) return [];
    if (Array.isArray(especs)) return especs;
    if (typeof especs === 'string') {
      try { return JSON.parse(especs); } 
      catch { return especs.split(',').map(e => e.trim()).filter(e => e); }
    }
    return [String(especs)];
  };

  const handleSelecionar = (id) => {
    if (servicoSelecionado === id) {
      setMobileAberto(!mobileAberto); // Toggle se já está selecionado
    } else {
      setServicoSelecionado(id);
      setMobileAberto(true); // Abre novo
    }
  };

  const servicosFiltrados = servicos.filter(s => s.tipo === tipoAtivo);
  const servicoAtivo = servicos.find(s => s.id === servicoSelecionado);

  if (loading) return <div className="loading">Carregando...</div>;

  return (
    <section id="precos" className="precos-catalogo">
      <div className="section-title">
        <h2>Investimento</h2>
        <p>Preços fixos. Sem surpresas.</p>
      </div>

      {/* Toggle */}
      <div className="tipo-toggle">
        <button 
          className={tipoAtivo === 'tecnologia' ? 'ativo' : ''}
          onClick={() => {
            setTipoAtivo('tecnologia');
            setMobileAberto(false);
            const primeiro = servicos.find(s => s.tipo === 'tecnologia');
            setServicoSelecionado(primeiro?.id);
          }}
        >
          <FiCode /> Tecnologia
        </button>
        <button 
          className={tipoAtivo === 'marketing' ? 'ativo' : ''}
          onClick={() => {
            setTipoAtivo('marketing');
            setMobileAberto(false);
            const primeiro = servicos.find(s => s.tipo === 'marketing');
            setServicoSelecionado(primeiro?.id);
          }}
        >
          <FiTrendingUp /> Marketing
        </button>
      </div>

      <div className="catalogo-container">
        {/* Lista */}
        <div className="lista-servicos">
          <h4>{tipoAtivo === 'tecnologia' ? 'Desenvolvimento' : 'Marketing'}</h4>
          
          {servicosFiltrados.map((servico) => {
            const isSelecionado = servicoSelecionado === servico.id;
            const isAberto = isSelecionado && mobileAberto;
            
            return (
              <div key={servico.id}>
                {/* Item da Lista */}
                <div
                  className={`item-servico ${isSelecionado ? 'ativo' : ''} ${servico.destaque ? 'destaque' : ''}`}
                  onClick={() => handleSelecionar(servico.id)}
                >
                  <div className="item-info">
<div className="item-titulo">
  {servico.destaque && <FiStar className="star" />}
  <span title={servico.nome}> 
    {servico.nome} 
  </span>
</div>
                    <div className="item-preco-compacto">
                      <span className="preco-principal">R$ {servico.preco_vista.toLocaleString('pt-BR')}</span>
                      {servico.parcelas > 1 && (
                        <span className="parcela-tag">ou {servico.parcelas}x</span>
                      )}
                    </div>
                  </div>
                  <FiChevronDown className={`seta ${isAberto ? 'aberta' : ''}`} />
                </div>

                {/* ACORDEÃO MOBILE - Aparece EMBAIXO do item */}
                {isAberto && (
                  <div className="acordeao-mobile">
                    <PainelDetalhes 
                      servico={servico} 
                      formatEspecificacoes={formatEspecificacoes} 
                      calcularPrecoPix={calcularPrecoPix} 
                      calcularParcela={calcularParcela} 
                      DESCONTO_PIX={DESCONTO_PIX} 
                    />
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* DESKTOP: Painel lateral fixo */}
        {servicoAtivo && (
          <div className="painel-desktop">
            <PainelDetalhes 
              servico={servicoAtivo} 
              formatEspecificacoes={formatEspecificacoes} 
              calcularPrecoPix={calcularPrecoPix} 
              calcularParcela={calcularParcela} 
              DESCONTO_PIX={DESCONTO_PIX} 
            />
          </div>
        )}
      </div>
    </section>
  );
}

// Componente do Painel (reutilizado)
function PainelDetalhes({ servico, formatEspecificacoes, calcularPrecoPix, calcularParcela, DESCONTO_PIX }) {
  const precoPix = Number(calcularPrecoPix(servico.preco_vista));
  const economia = servico.preco_vista - precoPix;
  return (
    <div className="painel-conteudo">
      {servico.destaque && <span className="tag-destaque"><FiStar /> Mais solicitado</span>}
      
      <h3>{servico.nome}</h3>
      
      {/* Preços Compactos */}
      <div className="precos-linha">
        <div className="preco-box pix">
          <span className="label">PIX 15% OFF</span>
          <span className="valor">R$ {precoPix.toLocaleString('pt-BR')}</span>
          <span className="economia">Economize R$ {economia.toFixed(2)}</span>
        </div>

        <div className="preco-box cartao">
          <span className="label">Cartão/Boleto</span>
          <span className="valor">R$ {servico.preco_vista.toLocaleString('pt-BR')}</span>
          {servico.parcelas > 1 && (
            <span className="parcelas">{servico.parcelas}x R$ {calcularParcela(servico.preco_vista, servico.parcelas)} s/juros</span>
          )}
        </div>
      </div>

      {/* Especificações */}
      <div className="bloco-especs">
        <h5><FiCheck /> Incluso:</h5>
        <ul>
          {formatEspecificacoes(servico.especificacoes).map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
      </div>

      {/* Info */}
      <div className="bloco-info">
        <div className="info-item">
          <FiCalendar />
          <div>
            <strong>Prazo:</strong> <span>{servico.prazo_entrega}</span>
          </div>
        </div>
        <div className="info-item">
          <FiShield />
          <div>
            <strong>Garantia:</strong> <span>{servico.garantia}</span>
          </div>
        </div>
        {servico.observacoes && (
            <div className="info-obs" style={{ marginTop: '1rem' }}>
    <h5>⚠️ Observações:</h5>
    <ul>
      {formatEspecificacoes(servico.observacoes).map((item, idx) => (
        <div key={idx}> {item}</div>
      ))}
    </ul>
  </div>
        )}
      </div>

      <a href={`https://wa.me/+5531971258912?text=Olá, queria mais informações sobre o serviço: ${encodeURIComponent(servico.nome)}`}
        target="_blank" 
        rel="noopener noreferrer"
        className="btn btn-primary btn-cta">
        Conversar no whatsapp <FiArrowRight />
      </a>
    </div>
  );
}

export default Precos;